const JourneyOutcomeDetail = {
  SKIPPED_BOOKING_JOURNEY: 'SKIPPED_BOOKING_JOURNEY',
  BOOKING_CONFIRMED: 'BOOKING_CONFIRMED',
  BOOKING_REQUEST_FAILED: 'BOOKING_REQUEST_FAILED',
  SUBSCRIPTION_NO_LONGER_MATCHED: 'SUBSCRIPTION_NO_LONGER_MATCHED',
  LEAD_ALREADY_RELEASED: 'LEAD_ALREADY_RELEASED',
  LEAD_NEVER_CONFIRMED: 'LEAD_NEVER_CONFIRMED',
  INACTIVITY_CUTOFF: 'INACTIVITY_CUTOFF',
  TERMINAL_CUTOFF: 'TERMINAL_CUTOFF',
  NO_SLOTS: 'NO_SLOTS',
  SLOTS_LOOKUP_FAILED: 'SLOTS_LOOKUP_FAILED',
  NO_LOCATIONS: 'NO_LOCATIONS',
  LOCATION_LOOKUP_FAILED: 'LOCATION_LOOKUP_FAILED',
  SOLAR_LOAD_FAILED: 'SOLAR_LOAD_FAILED',
  SOLAR_VERIFY_FAILED: 'SOLAR_VERIFY_FAILED',
  NO_SOLAR_POTENTIAL: 'NO_SOLAR_POTENTIAL',
  TIMED_OUT: 'TIMED_OUT',
};

export default JourneyOutcomeDetail;
